import methods from '@/enums/methods';
import api from '../api/thothV2';
import TransactionMonitoringService from './base';

class MerchantMonitoringService extends TransactionMonitoringService {
    monitoringMerchant({
        message,
        establishmentId,
    }) {
        return this.fetch({
            url: 'monitoring/clients/',
            data: {
                message,
                establishment_id: establishmentId,
            },
            method: methods.PUT,
        });
    }

    desmonitoringMerchant(ec, { message }) {
        return this.fetch({
            data: {
                message,
            },
            url: `monitoring/clients/${ec}`,
            method: methods.PUT,
        });
    }

    monitoredDetails() {
        return this.fetch({
            url: 'monitoring/clients/monitoring-history',
        });
    }

    monitoredDetail(ec) {
        return this.fetch({
            url: `monitoring/clients/${ec}/monitoring-history`,
        });
    }
}

export async function getEc(merchantId) {
    try {
        return await api.get(`monitoring/clients/${merchantId}`);
    } catch ({ response }) {
        return response;
    }
}

export default new MerchantMonitoringService();
